/* Performance Optimizations Configuration */

// Service Worker for caching (optional - uncomment to enable)
// This will cache static assets for offline access

export const register = () => {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          // Service worker registered successfully
        })
        .catch((registrationError) => {
          // Service worker registration failed
        });
    });
  }
};

export const unregister = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        // Error unregistering service worker
      });
  }
};

// Prefetch critical routes - now empty as components are lazy loaded
export const prefetchRoutes = () => {
  // Components are lazy loaded on demand for better initial performance
  // This function can be used to prefetch routes during idle time
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => {
      // Prefetch product images after initial load
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.as = 'image';
      // Add critical images here if needed
    });
  }
};

// Optimize third-party scripts
export const loadThirdPartyScripts = () => {
  // Load analytics or other third-party scripts after page load
  if (document.readyState === 'complete') {
    // Add your third-party scripts here
  } else {
    window.addEventListener('load', () => {
      // Add your third-party scripts here
    });
  }
};
